<template>
    <div class="container">
        <b-modal
            :model-value="modalEditaEcp"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            size="lg"
            :title="labels.editEcp"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
         @hide="clicked">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <div v-if="dataDetallEcp && dataDetallEcp.length > 0">
                    <!-- Contable -->
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.contable }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select 
                                v-model="dataDetallEcp[0].contable" 
                                class="form-input"
                                :disabled="readOnly"
                            >
                                <option :value="1">{{ labels.yes }}</option>
                                <option :value="0">{{ labels.not }}</option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <!-- Cuenta -->
                    <b-row class="d-flex align-items-center uniform-form-row" v-if="dataDetallEcp[0]?.contable == 1 ? true : showCuenta">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.account }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <h6 class="form-control-static">{{ dataDetallEcp[0]?.cuenta || '-' }}</h6>
                        </b-col>
                    </b-row>

                    <!-- Actual -->
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.actual }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="dataDetallEcp[0].actual" class="form-input" :disabled="readOnly">
                                <option value="1">{{ labels.yes }}</option>
                                <option value="0">{{ labels.not }}</option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <!-- Operación -->
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.operacion }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-select v-model="dataDetallEcp[0].operacion" class="form-input" :disabled="readOnly">
                                <option value="+">Suma</option>
                                <option value="-">Resta</option>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <!-- Formulación - CHECKBOX NATIVOS -->
                    <b-row class="d-flex align-items-center uniform-form-row" v-if="dataDetallEcp[0]?.contable == 0 ? true : showFormulacion">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.formulacion }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <div class="d-flex flex-wrap align-items-center gap-3">
                                <div class="custom-checkbox-wrapper" v-if="administrador">
                                    <input 
                                        type="radio"
                                        :id="'chk_m'"
                                        :value="'m'"
                                        v-model="chk"
                                        :disabled="readOnly"
                                    />
                                    <label :for="'chk_m'">Manual</label>
                                </div>
                                <div class="custom-checkbox-wrapper" v-if="administrador">
                                    <input 
                                        type="radio"
                                        :id="'chk_cons'"
                                        :value="'cons'"
                                        v-model="chk"
                                        :disabled="readOnly"
                                    />
                                    <label :for="'chk_cons'">Ajuste Consol</label>
                                </div>
                                <div class="custom-checkbox-wrapper">
                                    <input 
                                        type="radio"
                                        :id="'chk_sf'"
                                        :value="'sf'"
                                        v-model="chk"
                                        :disabled="readOnly"
                                    />
                                    <label :for="'chk_sf'">Fila</label>
                                </div>
                                <div class="custom-checkbox-wrapper">
                                    <input 
                                        type="radio"
                                        :id="'chk_sc'"
                                        :value="'sc'"
                                        v-model="chk"
                                        :disabled="readOnly"
                                    />
                                    <label :for="'chk_sc'">Columna</label>
                                </div>
                                <div class="custom-checkbox-wrapper">
                                    <input 
                                        type="radio"
                                        :id="'chk_c'"
                                        :value="'c'"
                                        v-model="chk"
                                        :disabled="readOnly"
                                    />
                                    <label :for="'chk_c'">Celda</label>
                                </div>
                                <div class="custom-checkbox-wrapper">
                                    <input 
                                        type="radio"
                                        :id="'chk_n'"
                                        :value="'n'"
                                        v-model="chk"
                                        :disabled="readOnly"
                                    />
                                    <label :for="'chk_n'">Niif</label>
                                </div>
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Suma Fila -->
                    <b-row class="d-flex align-items-center uniform-form-row" v-if="showSumaFila">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">Suma Fila:</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input v-model="dataDetallEcp[0].formulacion" type="text" class="form-input" :disabled="readOnly" />
                        </b-col>
                    </b-row>

                    <!-- Suma Columna -->
                    <b-row class="d-flex align-items-center uniform-form-row" v-if="showSumaColumna">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">Suma Columna:</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <b-form-input v-model="dataDetallEcp[0].formulacion" type="text" class="form-input" :disabled="readOnly" />
                        </b-col>
                    </b-row>

                    <!-- Celda -->
                    <b-row class="d-flex align-items-center uniform-form-row" v-if="showCelda">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">Celda:</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <div class="d-flex gap-2">
                                <b-form-input v-model="regFila" type="number" class="form-input" style="max-width: 100px;" :disabled="readOnly" />
                                <b-form-input v-model="regCol" type="number" class="form-input" style="max-width: 100px;" :disabled="readOnly" />
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Niif -->
                    <template v-if="showNiif">
                        <!-- Filtro NIIF -->
                        <b-row class="d-flex align-items-center uniform-form-row">
                            <b-col cols="12" md="4" class="text-left uniform-label-col">
                                <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">
                                    {{ labels.niifFilter }}
                                </label>
                            </b-col>
                            <b-col cols="12" md="8" class="text-left">
                                <div class="criterio-inputs-wrapper">
                                    <b-form-input 
                                        v-model="critNiifCode" 
                                        type="text" 
                                        class="form-input"
                                        style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                        autocomplete="off"
                                        :placeholder="labels.niifCodePlaceholder"
                                        @input="filtraNiifs"
                                        :disabled="readOnly"
                                    />
                                    <b-form-input 
                                        v-model="critNiifName" 
                                        type="text" 
                                        class="form-input"
                                        style="height: 34px; font-size: 13px;"
                                        autocomplete="off"
                                        :placeholder="labels.niifNamePlaceholder"
                                        @input="filtraNiifs"
                                        :disabled="readOnly"
                                    />
                                </div>
                            </b-col>
                        </b-row>

                        <!-- Tabla de NIIFs -->
                        <div class="accounts-section mt-2">
                            <div v-if="listNiifFiltered.length > 0" class="accounts-list mt-1">
                                <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                    <b-button 
                                        size="sm"
                                        style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                        @click="toggleSelectAllNiifs"
                                        :disabled="readOnly"
                                    >
                                        {{ selectAllNiifs ? labels.deselectAll : labels.selectAll }}
                                    </b-button>
                                    <span style="font-size: 13px; color: #6c757d;">
                                        {{ labels.selected }}: <strong>{{ arrNiif.length }}</strong> / {{ listNiifFiltered.length }}
                                    </span>
                                </div>

                                <div class="custom-scroll-table">
                                    <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                        <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                            <tr>
                                                <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                    {{ labels.code }}
                                                </th>
                                                <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                    {{ labels.niifName }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr 
                                                v-for="niif in listNiifFiltered" 
                                                :key="niif.id"
                                                @click="!readOnly && toggleNiifSelection(niif)"
                                                :class="{'table-active-blue': isNiifSelected(niif)}"
                                                :style="readOnly ? 'cursor: default;' : 'cursor: pointer;'"
                                            >
                                                <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                    <strong>{{ niif?.niif || '' }}</strong>
                                                </td>
                                                <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="niif.nameNiif">
                                                    {{ niif?.nameNiif || '' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div v-else-if="listNiif.length > 0 && !loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsMatch }}</span>
                            </div>

                            <div v-else-if="loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                <b-spinner small class="mr-1"></b-spinner>
                                <span style="font-size: 13px;">{{ labels.loadingNiifs }}</span>
                            </div>

                            <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                                <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsAvailable }}</span>
                            </div>
                        </div>
                    </template>

                    <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                        <b-button class="reset-btn-secondary" @click="clicked">
                            {{ labels.close }}
                        </b-button>
                        <b-button class="reset-btn-primary ml-2" @click="editaCuenta" :disabled="readOnly">
                            {{ labels.save }}
                        </b-button>
                    </div>
                </div>

                <div v-else class="text-center py-4">
                    <p>{{ labels.noData }}</p>
                    <b-button class="reset-btn-secondary mt-2" @click="clicked">
                        {{ labels.close }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PlanConsolidacion from '../../services/PlanConsolidacion';
import EcpReporte from '../../services/EcpReporte';

export default {
    name: "EditaCuentaEcp",
    props: {
        modalEditaEcp: {
            type: Boolean,
            default: false
        },
        dataDetallEcp: {
            type: Array,
            default: () => []
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        administrador: false,
        showCuenta: false,
        showFormulacion: false,
        chk: '',
        showNiif: false,
        showSumaFila: false,
        showSumaColumna: false,
        showCelda: false,
        regFila: "",
        regCol: "",
        listNiif: [],
        listNiifFiltered: [],
        arrNiif: [],
        selectAllNiifs: false,
        loadingNiifs: false,
        critNiifCode: "",
        critNiifName: "",
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    editEcp: "Editar Detalle ECP",
                    infoTitle: "Editar detalle",
                    infoText: "Modifica los datos del detalle ECP y guarda los cambios.",
                    save: "Guardar",
                    close: "Cerrar",
                    contable: "Contable:",
                    yes: "SI",
                    not: "NO",
                    account: "Cuenta:",
                    actual: "Actual:",
                    operacion: "Operación:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formulación:",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    noData: "No hay datos para editar",
                    selectedNiifs: "NIIF seleccionadas:",
                    niifFilter: "Filtro NIIF",
                    niifCodePlaceholder: "Buscar por código...",
                    niifNamePlaceholder: "Buscar por nombre...",
                    code: "Código",
                    niifName: "Nombre NIIF",
                    selected: "Seleccionadas",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    noNiifsAvailable: "No hay NIIF disponibles",
                    noNiifsMatch: "No hay NIIF que coincidan con el filtro",
                    loadingNiifs: "Cargando NIIF..."
                }
            } else {
                return {
                    editEcp: "Edit ECP Detail",
                    infoTitle: "Edit detail",
                    infoText: "Modify the ECP detail data and save the changes.",
                    save: "Save",
                    close: "Close",
                    contable: "Accountant:",
                    yes: "YES",
                    not: "NO",
                    account: "Account:",
                    actual: "Actual:",
                    operacion: "Operation:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formulation:",
                    vigencia: "Validity:",
                    company: "Company:",
                    noData: "No data to edit",
                    selectedNiifs: "Selected NIIF:",
                    niifFilter: "NIIF Filter",
                    niifCodePlaceholder: "Search by code...",
                    niifNamePlaceholder: "Search by name...",
                    code: "Code",
                    niifName: "NIIF Name",
                    selected: "Selected",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    noNiifsAvailable: "No NIIF available",
                    noNiifsMatch: "No NIIF match the filter",
                    loadingNiifs: "Loading NIIF..."
                }
            }
        }
    },
    methods: {
        isNiifSelected(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return false;
            return this.arrNiif.some(item => String(item) === String(niif.niif));
        },

        toggleNiifSelection(niif) {
            if (this.readOnly) return;
            if (!niif || niif.niif === undefined || niif.niif === null) return;
            const niifStr = String(niif.niif);
            const index = this.arrNiif.findIndex(item => String(item) === niifStr);
            if (index > -1) {
                this.arrNiif.splice(index, 1);
            } else {
                this.arrNiif.push(niif.niif);
            }
            this.updateSelectAllNiifs();
        },

        toggleSelectAllNiifs() {
            if (this.readOnly) return;
            this.selectAllNiifs = !this.selectAllNiifs;
            const arrNiifStr = this.arrNiif.map(item => String(item));
            
            if (this.selectAllNiifs) {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null);
                allCodes.forEach(code => {
                    const codeStr = String(code);
                    if (!arrNiifStr.includes(codeStr)) {
                        this.arrNiif.push(code);
                    }
                });
            } else {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null);
                const codesStr = allCodes.map(c => String(c));
                this.arrNiif = this.arrNiif.filter(code => !codesStr.includes(String(code)));
            }
        },

        updateSelectAllNiifs() {
            if (this.listNiifFiltered.length === 0) {
                this.selectAllNiifs = false;
                return;
            }
            const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null);
            const arrNiifStr = this.arrNiif.map(item => String(item));
            this.selectAllNiifs = allCodes.every(code => arrNiifStr.includes(String(code)));
        },

        filtraNiifs() {
            let filtered = [...this.listNiif];
            
            if (this.critNiifCode) {
                const codeFilter = this.critNiifCode.toUpperCase();
                filtered = filtered.filter(n => {
                    const code = n?.niif;
                    if (code === undefined || code === null) return false;
                    return String(code).toUpperCase().includes(codeFilter);
                });
            }
            
            if (this.critNiifName) {
                const nameFilter = this.critNiifName.toUpperCase();
                filtered = filtered.filter(n => {
                    const name = n?.nameNiif;
                    if (name === undefined || name === null) return false;
                    return String(name).toUpperCase().includes(nameFilter);
                });
            }
            
            this.listNiifFiltered = filtered;
            this.updateSelectAllNiifs();
        },

        getNiifName(code) {
            const found = this.listNiif.find(n => n?.niif === code);
            if (found) {
                return `${found.niif} - ${found.nameNiif || ''}`;
            }
            return code || '';
        },

        removeNiif(code) {
            if (this.readOnly) return;
            const index = this.arrNiif.indexOf(code);
            if (index > -1) {
                this.arrNiif.splice(index, 1);
                this.updateSelectAllNiifs();
            }
        },

        cargarNiif() {
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) {
                return;
            }
            
            this.loadingNiifs = true;
            
            const item = this.dataDetallEcp[0];
            const formulacionOriginal = item?.formulacion || '';
            
            PlanConsolidacion.getPlanConsPorCompVige(
                this.dataDetallEcp[0].vigencia,
                this.dataDetallEcp[0].codReporte
            )
            .then((res) => {
                const niifData = res.data.planConsNiif || [];
                this.listNiif = niifData;
                this.listNiifFiltered = [...niifData];

                const match = formulacionOriginal.match(/Niif\(([\d,]+)\)/);
                
                if (match && match[1]) {
                    const niifCodes = match[1].split(',').map(num => parseInt(num.trim()));
                    
                    const validCodes = this.listNiif.map(n => n?.niif).filter(code => code !== undefined && code !== null);
                    const existingCodes = niifCodes.filter(code => validCodes.includes(code));
                    
                    if (existingCodes.length > 0) {
                        this.arrNiif = existingCodes;
                    } else {
                        this.arrNiif = [];
                    }
                } else {
                    this.arrNiif = [];
                }
                
                this.updateSelectAllNiifs();
                this.loadingNiifs = false;
            })
            .catch((err) => {
                console.error('ERROR en cargarNiif:', err);
                this.listNiif = [];
                this.listNiifFiltered = [];
                this.loadingNiifs = false;
            });
        },

        async editaCuenta() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para editar.')
                return
            }

            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) {
                this.$toast.error('No hay datos para editar')
                return
            }

            if (this.chk == 'n') {
                if (this.arrNiif.length == 0) {
                    this.$toast.error("Niif sin seleccionar")
                    return
                }
            }

            this.dataDetallEcp[0].chkSel = this.chk

            if (this.chk == 'm') {
                this.dataDetallEcp[0].formulacion = "MANUAL"
            } else if (this.chk == 'n') {
                this.dataDetallEcp[0].formulacion = this.arrNiif
            } else if (this.chk == 'c') {
                this.dataDetallEcp[0].formulacion = 'CELDA(' + this.regFila + ',' + this.regCol + ')'
            }

            this.dataDetallEcp[0].idUser = this.$store.state.userId

            try {
                let updatDetEcp = await EcpReporte.updateDetCuentaEcp(this.dataDetallEcp[0])
                if (updatDetEcp.status == 200) {
                    this.$toast.success(updatDetEcp.data.message)
                    setTimeout(() => {
                        this.reloadTable()
                    }, 1500)
                } else {
                    this.$toast.error(updatDetEcp.data.message)
                }
            } catch (err) {
                console.error(err)
                this.$toast.error('Error al actualizar la cuenta')
            }
        },

        clicked() {
            this.$emit('cierraMod', false)
        },

        asignaCelda(celda) {
            if (!celda) return
            let filaCel = celda.indexOf('(')
            let fila = celda.slice(filaCel + 1, 8)
            this.regFila = fila
            let columnaCel = celda.indexOf(',')
            let columna = celda.slice(columnaCel + 1, 11)
            this.regCol = columna
        },

        reloadTable() {
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) return
            let info = {
                'vigencia': this.dataDetallEcp[0].vigencia,
                'companyId': this.dataDetallEcp[0].id_compania,
                'codReporte': this.dataDetallEcp[0].codReporte,
                'fila': this.dataDetallEcp[0].fila,
                'columna': this.dataDetallEcp[0].columna
            }
            this.$emit('reloadTable', info)
        },

        resetFormulacionData() {
            this.showNiif = false;
            this.showSumaFila = false;
            this.showSumaColumna = false;
            this.showCelda = false;
            this.critNiifCode = "";
            this.critNiifName = "";
            this.selectAllNiifs = false;
        }
    },
    mounted() {
        if (this.$route.name == "ecpReporteADM") {
            this.administrador = true
        }
    },
    watch: {
        dataDetallEcp: {
            immediate: true,
            handler(valNew) {
                if (!valNew || valNew.length === 0) {
                    return;
                }
                
                const item = valNew[0];
                
                if (!item) {
                    return;
                }

                const formulacion = item.formulacion || '';
                const contable = item.contable;

                if (formulacion.slice(0, 1) == "M") {
                    this.chk = 'm';
                    this.resetFormulacionData();
                } else if (formulacion.slice(0, 1) == "") {
                    this.chk = '';
                    this.resetFormulacionData();
                } else if (formulacion.slice(0, 1) == "N" && contable == 0) {
                    this.chk = 'n';
                    this.showNiif = true;
                    this.cargarNiif();
                } else if (formulacion.slice(0, 5) == "SUMAF" && contable == 0) {
                    this.chk = 'sf';
                    this.showSumaFila = true;
                    this.resetFormulacionData();
                } else if (formulacion.slice(0, 5) == "SUMAC" && contable == 0) {
                    this.chk = 'sc';
                    this.showSumaColumna = true;
                    this.resetFormulacionData();
                } else if (formulacion.slice(0, 2) == "CE" && contable == 0) {
                    this.chk = 'c';
                    this.showCelda = true;
                    this.resetFormulacionData();
                    this.asignaCelda(formulacion);
                } else if (formulacion.slice(0, 2) == "CM" && contable == 0) {
                    this.chk = 'cons';
                    this.resetFormulacionData();
                } else {
                    this.resetFormulacionData();
                }
            }
        },

        chk(valNew) {
            if (!this.dataDetallEcp || this.dataDetallEcp.length === 0) return
            
            if (this.showNiif && valNew === 'n') {
                return;
            }
            
            this.resetFormulacionData()

            if (valNew == "m") {
                this.dataDetallEcp[0].formulacion = ""
                this.dataDetallEcp[0].chkSel = valNew
            } else if (valNew == "cons") {
                this.dataDetallEcp[0].formulacion = ""
                this.dataDetallEcp[0].chkSel = valNew
            } else if (valNew == "n") {
                this.dataDetallEcp[0].formulacion = ""
                this.showNiif = true
                this.dataDetallEcp[0].chkSel = valNew
                this.cargarNiif()
            } else if (valNew == "sf") {
                this.showSumaFila = true
                this.dataDetallEcp[0].chkSel = valNew
                this.dataDetallEcp[0].formulacion = ""
            } else if (valNew == "sc") {
                this.showSumaColumna = true
                this.dataDetallEcp[0].chkSel = valNew
                this.dataDetallEcp[0].formulacion = ""
            } else if (valNew == "c") {
                this.showCelda = true
                this.dataDetallEcp[0].chkSel = valNew
                if (this.dataDetallEcp[0].formulacion) {
                    this.asignaCelda(this.dataDetallEcp[0].formulacion)
                }
                this.dataDetallEcp[0].formulacion = ""
            }
        },

        modalEditaEcp(valNew) {
            if (valNew && this.dataDetallEcp && this.dataDetallEcp.length > 0) {
                // El watch de dataDetallEcp ya se encarga de cargar los datos
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS PARA SELECTOR NIIF INLINE ========== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
}

.select-all-container {
    padding: 4px 0;
}

.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table thead th:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

.custom-scroll-table table thead th:last-child {
    width: auto !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    width: auto !important;
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* CHECKBOX NATIVOS - ESTILOS PERSONALIZADOS */
.custom-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.custom-checkbox-wrapper input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #2e507a;
    cursor: pointer;
    margin: 0;
    flex-shrink: 0;
}

.custom-checkbox-wrapper input[type="radio"]:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.custom-checkbox-wrapper label {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #495057;
    cursor: pointer;
}

.custom-checkbox-wrapper input[type="radio"]:disabled + label {
    cursor: not-allowed;
    opacity: 0.6;
}

/* Estilos generales del modal */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.password-policy-box {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 16px 20px;
    border-left: 4px solid #2e507a;
}

.password-policy-title {
    font-size: 16px;
    font-weight: 600;
    color: #2e507a;
}

.password-policy-subtitle {
    font-size: 14px;
    color: #6c757d;
}

.uniform-form-row {
    margin-bottom: 10px;
}

.uniform-label-col {
    padding-right: 15px;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        font-size: 11px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
}

@media (max-width: 576px) {
    .password-policy-box {
        padding: 12px 16px;
    }
    
    .password-policy-title {
        font-size: 14px;
    }
    
    .password-policy-subtitle {
        font-size: 13px;
    }
    
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 60px !important;
        min-width: 60px !important;
        max-width: 60px !important;
        font-size: 10px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }

    .custom-checkbox-wrapper {
        gap: 4px;
    }

    .custom-checkbox-wrapper input[type="radio"] {
        width: 14px;
        height: 14px;
    }

    .custom-checkbox-wrapper label {
        font-size: 13px;
    }
}
</style>